export const state = () => ({
  userId: null,
  user: null,
  isStripeVerified: null,
  shopName: null
})

export const mutations = {
  updateUser(state, value) {
    state.userId = value ? value.id : null
    state.user = value
    state.isStripeVerified = value ? value.isStripeVerified : null
    state.shopName = value ? value.shopName : null
  },
  signOutUser(state) {
    state.userId = null
    state.user = null
    state.isStripeVerified = null
    state.shopName = null
  }
}

export const actions = {
  async updateUser({ commit }, user) {
    commit('updateUser', user)
  },
  async signOutUser({ commit }) {
    commit('signOutUser')
  }
}
